import type { JiraIntegration } from "@p0security/integrations-core";

/** Integration keys of the findings trackers that file Jira issues, the one
 * that files a tenant's findings first. A tenant moving off `jira` has both
 * installed for a while, and `jira-tracker` files its findings, as the
 * backend's `tenantTracker` picks it.
 */
export const JIRA_TRACKER_KEYS = ["jira-tracker", "jira"] as const;

export type JiraTrackerKey = (typeof JIRA_TRACKER_KEYS)[number];

/** The fields of a Jira tracker's integration doc that the assessment UI reads */
export type JiraTrackerDoc = Pick<JiraIntegration, "state">;
